import { render, staticRenderFns } from "./DepartUserInfo.vue?vue&type=template&id=b6c2c722&scoped=true&"
import script from "./DepartUserInfo.vue?vue&type=script&lang=js&"
export * from "./DepartUserInfo.vue?vue&type=script&lang=js&"
import style0 from "./DepartUserInfo.vue?vue&type=style&index=0&id=b6c2c722&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6c2c722",
  null
  
)

export default component.exports